import React from "react";

const TableHeader = ({ name, className }) => (
  <th className={`p-2 font-normal uppercase text-left ${className}`}>{name}</th>
);

export default TableHeader;
